import React, { Fragment } from "react";
import Navbar3 from "../../components/Navbar3/Navbar3";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import WebSolutionsSection from "../../components/WebSolutionsSection/WebSolutionsSection";
import webi1 from "../../images/service/img-1.png";
import webi2 from "../../images/service/img-2.png";
import webi3 from "../../images/service/img-3.jpeg";
import webi4 from "../../images/service/img-4.png";
import webi5 from "../../images/service/img-5.png";
import webi6 from "../../images/service/img-6.jpeg";
import webi7 from "../../images/service/img-7.png";
import webi8 from "../../images/service/img-8.png";
import WelcomeSection from "../../components/WelcomeSection/WelcomeSection";
import ExpertiseSection from "../../components/ExpertiseSection/ExpertiseSection";
import MarketingSection from "../../components/MarketingSection/MarketingSection";
import BoostBusinessSection from "../../components/BoostBusinessSection/BoostBusinessSection";

const services = [
  {
    title: "Pay Per Click (PPC)",
    description:
      "Get the most out of your online presence with well-crafted PPC campaigns. We help you reach your audience precisely, ensuring every click is worth it and every dollar spent brings back results.",
    image: webi1,
    bgColor: "#ffab91",
  },
  {
    title: "Search Engine Optimization",
    description:
      "Boost your brand's visibility on search engines with our SEO. We fine-tune your online presence to help your content shine, attract organic traffic, and build your online reputation.",
    image: webi2,
    bgColor: "#80cbc4",
  },
  {
    title: "Marketing Automation",
    description:
      "Make marketing efforts smoother & more efficient with automation. We create & implement marketing automation strategies that nurture leads & boost conversion rates, saving you time & effort.",
    image: webi3,
    bgColor: "#ce93d8",
  },
  {
    title: "Email Marketing",
    description:
      "Tap into the power of personalized email campaigns that hit home. Our email marketing services help you connect with your audience, delivering content that resonates and gets them to take action.",
    image: webi4,
    bgColor: "#fbc02d",
  },
  {
    title: "Content Creation",
    description:
      "Engaging & valuable content is key to digital success. Our content creation team produces concepts that informs, engages, & inspires audience, whether it's blogs, articles, videos, or social media updates.",
    image: webi5,
    bgColor: "#b39ddb",
  },
  {
    title: "Graphics Design",
    description:
      "Visual appeal is super important in digital marketing. Our graphic design services make sure your brand's look matches your message, leaving a memorable impression on your audience.",
    image: webi6,
    bgColor: "#ffab91",
  },
  {
    title: "CR/PR Management",
    description:
      "Enhance your customer and partner relationships with our CRM/PRM solutions. We help set up efficient systems that boost communication and collaboration while providing personalized experiences.",
    image: webi7,
    bgColor: "#ce93d8",
  },
  {
    title: "Social Media - SMM",
    description:
      "Social media is a lively space for connecting. Our SMM services cover both marketing and management, making sure your social media game is not just active but also smart and effective.",
    image: webi8,
    bgColor: "#ffab91",
  },
];

const heading = "Your plate with full of nutritions";

const serviceContent =
  "At Europa Solutions, we offer a spectrum of services that combine the art of digital marketing with the science of content creation, ensuring your brand excels in the digital landscape. Here's an overview of the services we provide:";

const ServicePageS2 = () => {
  return (
    <Fragment>
      <div
        style={{
          backgroundImage: `url('/img/webbg.jpeg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          position: "relative",
        }}
      >
        <Navbar3 topbarNone={"wpo-header-style-6"} />
        <PageTitle
          pageTitle={"Explore Digital Success with DigiTally"}
          pageSub={
            "Your Pathway to Dynamic Digital Marketing Solutions. Unlock your brand's potential with innovative strategies."
          }
          backgroundImage={require("../../images/web-1.jpeg")}
        />
        <ExpertiseSection />
        <WebSolutionsSection
          webSolutions={services}
          heading={heading}
          serviceContent={serviceContent}
        />
        <BoostBusinessSection />
        <MarketingSection />
        <WelcomeSection
          title="Establish a Connection with Our Team for Digital Marketing Excellence"
          subtitle="Getting started is easy! Contact us via our website, email, or call. We’ll create a custom strategy and use great tech for results. We’ll support you throughout, ensuring your digital marketing thrives. Let’s start this journey together—reach out to achieve your goals!"
          buttonText="Contact Us"
        />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default ServicePageS2;
